// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'
import PayjpCheckout from 'vue-payjp-checkout'
Vue.use(PayjpCheckout)

Vue.config.productionTip = false
const firebaseConfig = {
  apiKey: 'AIzaSyDhpQ-JTc6AdZtjm0xh4Mk8cUxtrSbcxVo',
  authDomain: 'kcal-27d27.firebaseapp.com',
  databaseURL: 'https://kcal-27d27.firebaseio.com',
  projectId: 'kcal-27d27',
  storageBucket: 'kcal-27d27.appspot.com',
  messagingSenderId: '170880925448',
  appId: '1:170880925448:web:d10515b90283d625e576bd'
}
firebase.initializeApp(firebaseConfig)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js